// extracted by mini-css-extract-plugin
export default {"terms":"Terms--terms--6I1G6"};